module.exports = __webpack_public_path__ + "static/media/desktop.3ede466c.png";